<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="outselect" v-if="!item.hidden" :inputflag="item.inputflag"
						:event="item.event" @remoteMethodtows="remoteMethodtows" :selcoms="item.selcoms" :key="index"
						:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
						:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Outboundreportmanagementtable ref="Outtable" :tableDataMD="tableDataMD" @onRowClick="onRowClick"
					@OtherOutExport="OtherOutExport" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Outboundreportmanagementtable>
			</div>
			<div class="TableBox"
				style=" margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
				<Outboundreportmanagement :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique"
					:dpmid="dpmid"></Outboundreportmanagement>
			</div>

			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Outboundreportmanagementtable from './components/outboundreportmanagementtable.vue'
	import Outboundreportmanagement from './components/outboundreportmanagement-bottom.vue'

	import utils from '../../../common/utils'
	import {
		wmsOtherOutList,
		wmsOtherOutExport,
		InventoryClassList,
		InventoryClassInfo,
		CusType,
		HelperDPVoucherType,
		Status,
		wmsOtherOutDetail,
		wmsOtherOutDetailUnique,
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Outboundreportmanagementtable,
			Outboundreportmanagement
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				dialogVisibles: false,
				tableDataDetail: [],
				tableDataUnique: [],
				tableDataMD: [],
				type: 0,
				wtype: 1,
				formdata: [{
						inputdata: '',
						title: '平台/经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '95px',
						inputflag: false
					},
					{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px',
						options: [],
						selcoms: false,
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '100px'
					},
					{
						hidden: true,
						inputdata: '',
						title: '付款方名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '95px',
						options: [],
					},

					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '100px',
						options: [],
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '100px'
					},
					{
						hidden: true,
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '100px',
						options: []
					},
					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '300px',
						lablewith: '105px'
					},
					{
						hidden: true,
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '制单人',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '95px'
					}
				],
				dpmid: '',
				fromdatalist: [],
				loading: true,
				from: {
					cusName: "",
					vouCode: "",
					objName: "",
					dpDate1: "",
					dpDate2: "",
					statuss: null,
					invClass: "",
					voucherType: "",
					verifyTime1: "",
					verifyTime2: "",
					invAddCode: "",
					invName: "",
					batch: "",
					TerminalHPName: "",
					CreatorName: ''
				}
			}
		},
		mounted() {
			this.cusType()
			this.helperDPVoucherType()
			this.status()
			this.inventoryClassList()
			this.wmsOtherOutList()
		},
		methods: {
			// 列表
			async wmsOtherOutList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await wmsOtherOutList({
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					objName: this.from.objName,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					status: this.from.statuss,
					invClass: this.from.invClass,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					invAddCode: this.from.invAddCode,
					invName: this.from.invName,
					batch: this.from.batch,
					TerminalHPName: this.from.TerminalHPName,
					CreatorName: this.from.CreatorName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					loading.close();
					this.tableData = data.data
				} else {
					loading.close();
				}
			},
			// 导出
			async wmsOtherOutExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await wmsOtherOutExport({
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					objName: this.from.objName,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					status: this.from.statuss,
					invClass: this.from.invClass,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					invAddCode: this.from.invAddCode,
					invName: this.from.invName,
					batch: this.from.batch,
					TerminalHPName: this.from.TerminalHPName,
					CreatorName: this.from.CreatorName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					utils.downloadFile(resexprot.data, "出库上报" + date.getTime(), "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close();
			},
			OtherOutExport() {
				this.wmsOtherOutExport()
			},
			onRowClick(val) {
				if (val.DPMID) {
					this.dpmid = val.DPMID
					this.wmsOtherOutDetail()
					this.wmsOtherOutDetailUnique()
				}
			},
			// 明细
			async wmsOtherOutDetail() {
				let {
					data,
					code
				} = await wmsOtherOutDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
					this.tableDataMD = data
				}
			},
			// 唯一码
			async wmsOtherOutDetailUnique() {
				let {
					data,
					code,
					message
				} = await wmsOtherOutDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					this.tableDataMD = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[5].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async helperDPVoucherType() {
				let {
					code,
					data
				} = await HelperDPVoucherType({})
				if (code == 0) {
					this.formdata[7].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[7].options.push(obj)
					})

				}

			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[4].options.push(obj)
					})

				}

			},
			async cusType() {
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				//console.log(code, data);
				if (code == 0) {
					if (data.CusType == "") {
						this.formdata[0].inputflag = true
					} else {
						this.formdata[0].inputflag = false
					}
				}
			},
			// 经销商名称远程搜索下拉
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await CusType({
					hpName: query
				})
				if (code == 0) {
					this.formdata[1].options = []
					let obj = {
						key: data.CusCode,
						value: data.CusType
					}
					this.formdata[1].options.push(obj)
					this.loading = false
				}
			},
			reset() {

				for (let index in this.$refs.outselect) {
					if (index == 2 || index == 5) {
						this.$refs.outselect[index].startTime = ''
						this.$refs.outselect[index].endTime = ''
					} else {
						this.$refs.outselect[index].modelvalue = ''
					}
				}
			},
			cancel() {
				//console.log('name')
				this.dialogVisibles = false
			},
			dialogOK() {
				//console.log('name2')
				this.dialogVisibles = false
			},
			select() {
				// for (let item of this.formdata) {
				//   this.fromdatalist.push(item.inputdata)
				// }
				console.log(this.$refs.outselect);
				this.pageindex = 1
				try {
					this.from.cusName = this.$refs.outselect[0].modelvalue
					this.from.vouCode = this.$refs.outselect[1].modelvalue
					this.from.dpDate1 = this.$refs.outselect[2].startTime
					this.from.dpDate2 = this.$refs.outselect[2].endTime
					//this.from.objName = this.$refs.outselect[3].modelvalue
					this.from.statuss = this.$refs.outselect[3].modelvalue
					this.from.invClass = this.$refs.outselect[4].modelvalue
					this.from.verifyTime1 = this.$refs.outselect[5].startTime
					this.from.verifyTime2 = this.$refs.outselect[5].endTime
					// this.from.voucherType = this.$refs.outselect[7].modelvalue
					this.from.invAddCode = this.$refs.outselect[6].modelvalue
					this.from.invName = this.$refs.outselect[7].modelvalue
					this.from.batch = this.$refs.outselect[8].modelvalue
					
					this.from.CreatorName = this.$refs.outselect[9].modelvalue
					console.log(this.$refs.outselect);
					// this.from.TerminalHPName = this.$refs.outselect[11].modelvalue
					this.wmsOtherOutList()
				} catch (error) {
					this.wmsOtherOutList()
				}
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wmsOtherOutList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wmsOtherOutList()
			},
		},
		watch: {
			// type: {
			//   deep: true,
			//   immediate: true,
			//   handler(newValue, oldValue) {
			//     if (this.wtype == 1) {
			//       //console.log(newValue, this.wtype, '/////');
			//       if (newValue == 0) {
			//         this.editops = true
			//         // //console.log(this.editops,'0');
			//       } else {
			//         this.editops = false
			//         // //console.log(this.editops,'1');
			//       }
			//     } else if (this.wtype == 0) {
			//       //console.log(newValue, this.wtype, 'newVal');
			//       this.editops = false
			//     }
			//   }
			// },
			// wtype: {
			//   deep: true,
			//   immediate: true,
			//   handler(newValue, oldValue) {

			//     //console.log(newValue, 'wtype');
			//     if (newValue == 0) {
			//       this.editops = false
			//     } else {
			//       if (this.type == 0) {
			//         this.editops = true
			//       } else {
			//         this.editops = false
			//       }
			//     }
			//   }
			// },
		}
	}
</script>

<style lang="less" scoped>
	.TableBox {
		margin-top: 10px;
		box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px 0px;
		background-color: rgb(255, 255, 255);
	}

	.inputtop {
		width: 980px;
		height: 130px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 5px;
		width: 300px;
		height: 50px;
		background-color: #fff;
		position: relative;
		bottom: 140px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: -5px;
	}
</style>